import React, { useState } from "react";

import { Link } from "react-router-dom"
import axios from "axios";
import PimaForm from "../forms/pimaForm/Form"
import {type PostData, type IOverideItem, type ICheckedITem, EXPORT_FORMAT_FIXED_COLUMN, EXPORT_FORMAT_EXTENDED_VARIABLE_ROWS, EXPORT_FORMAT_VARIABLE_COLUMN, MAX_PRODUCT_COMPETITORS} from "../interface/iUpload"
import SettingsLayout from "../layouts/settings/Settings";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DropDown, {DropDownSelectionHandleType} from "../core/dropdown/DropDown";
import PrimaryButton from "../core/buttons/Primary/Primary";
import _ from "lodash";
import { saveAs } from 'file-saver';
import stylesConfig from '../theme/config';
import { styled } from '@mui/system';

import OverideHotSearchAndCopy from "../core/hotsearch/Hotsearch";
import { Checkbox, FormControlLabel, SelectChangeEvent } from "@mui/material";
import {convertBuff} from '../../utility/utility'
import RowRadioButtonsGroup from "../core/buttons/GroupRadios/GroupRadios";
import authServices from "../services/auth-services/auth-services";

import ExcelJS from 'exceljs';




export interface IExportConfig {
  showResultBeforeExport: boolean;
  showProjectType: boolean;
  showContentSummary: boolean;
  showProductCompetitors: boolean;
  showProductPricing: boolean;
  exportFormat: number;
}
const PimaUpload: React.FunctionComponent = () => {

  const [formValues, setFormValues] = useState<PostData>({
    email: "",
    image: null,
    file: null,
  });


  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [progress, setProgress] = useState(0);

  const [resData, setResData] = useState([]);//submit outbound data
  const [overideItems, setOverideItems] = useState<IOverideItem[]>([])//overide column

  const [errorRows, setErrorRows] = useState<number[]>([])

  const [toggleShowAll, setToggleShowAll] = useState<boolean>(true)
  const [exportConfig, setExportConfig] = useState<IExportConfig>({
                                              showResultBeforeExport: true,
                                              showProjectType: false,
                                              showContentSummary: false,
                                              showProductCompetitors: false,
                                              showProductPricing: false,
                                              exportFormat: EXPORT_FORMAT_FIXED_COLUMN
                                            })

  const uploadForm = async (formData: FormData, url: string) => {
    setIsLoading(true);
   return await axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*"
      },
      onUploadProgress: (progressEvent) => {
        const progress = (progressEvent.loaded / progressEvent.total) * 50;
        setProgress(progress);
      },
      onDownloadProgress: (progressEvent) => {
        const progress = 50 + (progressEvent.loaded / progressEvent.total) * 50;
        //console.log(progress);
        setProgress(progress);
      },
    })
  };


  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      email: event.target.value,
    }));
  };


  const handleFileChange = (newValue: any) => {
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      file: newValue,
    }));
  };

  const handleSubmit = async (e: any) => {
    const url = process.env.REACT_APP_API_UPLOAD;

    e.preventDefault();
    if(!formValues.email || !formValues.file)
    { alert('please, enter your email or upload your document... ');
      return;
  }
  let isAuth = true;


    const formData = new FormData();
    formData.append("email", formValues.email);
    formValues.file && formData.append("file", formValues.file);
     //upload post request and update status
     if(!url)return;
    await uploadForm(formData, url)
          .then ( async (response) => {
            setProgress(100);
            await new Promise((resolve) => {
              setTimeout(() => resolve("success"), 500);
            });
            setIsSuccess(true);
            setProgress(0);
            // const responseData = 
            setResData(response.data)//first render table

            const initialOverideItem : IOverideItem = {isChecked: false, checkedItem: null}
            setOverideItems(new Array(Object.values(response.data).length).fill(initialOverideItem))
          }).catch((error)=>{
            console.log(error);
            console.log(error.response);
            setIsSuccess(false);
            setProgress(0);
            const message = error.response?.data?.message
              || error.response?.data?.error
              || error.message
              || 'An unexpected error occurred. Please try again.';
            alert(message);
          })
  };


  const handleSelectionChange = (selectItem: any, rowNumber: string)=>{
    //update 
    //console.log("in select change");
    if(!selectItem || !resData)return;

    //console.log("in select change2");
    const updatedData = {
      ...resData,
      [rowNumber]:{
        ...resData[rowNumber],
        userSelected: true,
        
        userSelectedItem: selectItem,
        processLog:'USER_SELECTION'
      }
    }

    setResData(updatedData)// product name dropdown selection update
  }

    const handleCopyClick = (_: any, currentIndex: number): void => {
        const nextIndex = currentIndex + 1;
        if (
            !resData?.[currentIndex + 1] ||
            !resData?.[nextIndex + 1]
        ) {
            return;
        }

        const newOverrideItems = [...overideItems];
        const { isChecked } = overideItems[currentIndex];
        const currentRow = resData[currentIndex + 1];
        let newCheckedItem: {
            productId: any;
            productName: any;
            vendorId: any;
            vendorName: any;
            description: any;
            label: string;
            isExchange: boolean;
            group: string
        } = null;

        if (isChecked) {
            // OVERRIDE TICKED → copy SERVICE VENDOR >> SERVICE NAME
            const mp = newOverrideItems[currentIndex].checkedItem;
            newCheckedItem = {
                label:       mp.label,
                productId:   mp.productId,
                productName: mp.productName,
                vendorId:    mp.vendorId,
                vendorName: mp.vendorName,
                description: mp.description,
                group:       mp.group,
                isExchange:  mp.isExchange,
            };
        } else {
            // OVERRIDE NOT TICKED → your existing product-copy logic
            if (currentRow.status === matchStatus.SINGLE_MATCH.ID) {
                const mp = currentRow.matchedProduct;
                newCheckedItem = {
                    label:       `${mp.vendor} >> ${mp.name}`,
                    productId:   mp.id,
                    productName: mp.name,
                    vendorId:    mp.vendorId,
                    vendorName: mp.vendor,
                    description: (mp.description ?? "").replace(/<\/?[^>]+(>|$)/g, ""),
                    group:       "Products",
                    isExchange:  false,
                };
            } else {
                const sel =
                    currentRow.userSelectedItem ??
                    Object.values(currentRow.multiMatched || {})[0];
                if (sel) {
                    const grp = sel.isExchange ? "Exchanges" : "Products";
                    newCheckedItem = {
                        label:       `${sel.vendorName} >> ${sel.productName}`,
                        productId:   sel.productId,
                        productName: sel.productName,
                        vendorId:    sel.vendorId,
                        vendorName: sel.vendorName,
                        description: sel.description,
                        group:       grp,
                        isExchange:  sel.isExchange,
                    };
                }
            }
        }

        if (newCheckedItem) {
            newOverrideItems[nextIndex] = {
                isChecked:   true,
                checkedItem: newCheckedItem,
            };
            setOverideItems(newOverrideItems);
        }
    };


    const handleDropDownCopyClick = (selectDropDownItem: string, rowIndex: number) => {

      //console.log("selected: " +selectDropDownItem);
      //console.log("currentIndex: " +currentIndex);

      // do nothing
        //console.log("nothing to copy")
    if (selectDropDownItem === '0' || selectDropDownItem === '1' )  return;

        // resData starts at 1 not 0. rowIndex is a 0 based array
        const srcIdx  = rowIndex + 1;
        const dstIdx  = srcIdx + 1;
        const srcRow  = resData[srcIdx];
        const dstRow  = resData[dstIdx];
        if (!srcRow || !dstRow) return;

        const item = srcRow.userSelectedItem ?? {
            productId:   srcRow.matchedProduct.id,
            productName: srcRow.matchedProduct.name,
            vendorName:  srcRow.matchedProduct.vendor,
            vendorId:    srcRow.matchedProduct.vendorId,
            description: srcRow.matchedProduct.description?.replace(/<\/?[^>]+(>|$)/g,'') ?? ''
        };
        const pid = item.productId;

        const newData = { ...resData };

        // 1) STATIC → DROPDOWN
        if (srcRow.status === 1 && dstRow.status === 2) {
            const mm = { ...dstRow.multiMatched };
            if (!mm[pid]) mm[pid] = {
                id:          pid,
                name:        item.productName,
                vendor:      item.vendorName,
                vendorId:    item.vendorId,
                description: item.description
            };
            newData[dstIdx] = {
                ...dstRow,
                multiMatched: mm,
                userSelected: true,
                userSelectedItem: {
                    productId:   pid,
                    productName: item.productName,
                    vendorName:  item.vendorName,
                    vendorId:    item.vendorId,
                    description: item.description
                },
                processLog: 'USER_SELECTION'
            };
            setResData(newData);
            return;
        }

   //     2) ANY STATIC/NO-ITEM → STATIC
        if (dstRow.status !== 2) {
            newData[dstIdx] = {
                ...dstRow,
                status: 1,
                matchedProduct: { id: pid, name: item.productName, vendor: item.vendorName, vendorId: item.vendorId, description: item.description }
            };
            return setResData(newData);
        }

        // 3) DROPDOWN → DROPDOWN
        const mm = { ...(dstRow.multiMatched || {}) };
        if (!mm[pid]) {
            mm[pid] = {
                id:          pid,
                name:        item.productName,
                vendor:      item.vendorName,
                vendorId:    item.vendorId,
                description: item.description
            };
        }

        newData[dstIdx] = {
            ...dstRow,
            status:        2,
            multiMatched:  mm,
            userSelected:  true,
            userSelectedItem: {
                productId:   pid,
                productName: item.productName,
                vendorName:  item.vendorName,
                vendorId:    item.vendorId,
                description: item.description
            },
            processLog: 'USER_SELECTION'
        };

        setResData(newData);
        return;
    };

    const checkboxOnChange = (currentIndex: number) => {
      const newOverideItems = [...overideItems]
      const currentItem = { ...newOverideItems[currentIndex]}
      //if kick off, needs clear dropdown selection from resData
      const rowNumber = currentIndex+1
      const updatedData = {
        ...resData,
        [rowNumber]:{
          ...resData[rowNumber],
          userSelected: false,
          userSelectedItem: null,
          processLog:''
        }
      }
      setResData(updatedData)// product name dropdown selection update
      //if un-kick off, needs clear hotword
      const newCheckedItem: ICheckedITem | null = currentItem.isChecked ? null : currentItem.checkedItem
      const newOverItem: IOverideItem = {
        isChecked: !currentItem.isChecked,
        checkedItem: newCheckedItem
      }
      newOverideItems[currentIndex] = newOverItem;

      setOverideItems(newOverideItems)
    }

    const handleAsyncHotWordToParentByIndex = (currentIndex: number, itemSelected: ICheckedITem)=> {// clear to '' in hotWords by index
      const newOverideItems = [...overideItems]
      const item = { ...newOverideItems[currentIndex]}
      const newOverItem: IOverideItem = {
        ...item, 
        checkedItem: itemSelected
      }
      //console.log('handleAsyncHotWordToParentByIndex', newOverItem)

      newOverideItems[currentIndex] = newOverItem;

      setOverideItems(newOverideItems);
    }

    const matchStatus = {
      SINGLE_MATCH: 
      {
        ID: 1,
        TEXT: 'SINGLE MATCHED'
      },
      MULTIPLE_MATCH:  {
        ID: 2,
        TEXT: 'MULTIPLE MATCHED'
      },
      NONE_MATCH:   {
        ID: 3,
        TEXT: 'NO MATCHED'
      },
    }

    const useSelectType = {
      MULTIPLE_SELECTION: 2,
      OVERRIDE_SELECTION: 3
    }
    const getTypeContentData =(url: string, reqBody:any)=> fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(reqBody),
     })
     .then((response) => response.json())
     .then((responseJson) => {
       return responseJson;
     })
     .catch((error) => {
       console.error(error);
     });

    const downloadExcel = async (e: any) => {
      e.preventDefault();

    //   //transform xls
    //if(validatedRowNums.length === 0){//pass validation
      // 1 integrated two array object, if overide is checked, will overide item and update resData 
      const newResData = [...Object.entries(resData)];
      //console.log(overideItems);

      overideItems.forEach((overideItem: IOverideItem, index)=>{
          if(overideItem.isChecked){
            if(overideItem.checkedItem === null) {
              overideItem.isChecked = false;
            }else {
              newResData[index][1].userSelected = true;
              newResData[index][1].userSelectType = useSelectType.OVERRIDE_SELECTION;
              newResData[index][1].userSelectedItem  = overideItem.checkedItem;
              newResData[index][1].processLog  = "USER_OVERRIDE";
            }
          }
      });

      //2 update userSelectedItem in resData for status:1 single_match(not userSelected); 2multiple-selection done handleSelectionChange when dropdown selection already updated for resData
      newResData.forEach(resRowEntries=>{
        const currentValue = resRowEntries[1]
        if(currentValue.status === matchStatus.SINGLE_MATCH.ID && !currentValue.userSelected) {
          const matchedProduct = currentValue.matchedProduct
      
          currentValue.processLog = matchStatus.SINGLE_MATCH.TEXT
          currentValue.userSelectedItem  = 
          {
            label:`${matchedProduct.name} >> ${matchedProduct.vendor}`, 
            productId: matchedProduct.id,  
            vendorId: matchedProduct.vendorId,
            description: matchedProduct.description?.replace(/<\/?[^>]+(>|$)/g, "") ?? null,
            productName: matchedProduct.name,
            vendorName: matchedProduct.vendor,
          };
        }
      });
      //console.log('newResData', newResData)

      //console.log('resData', resData)
  
      let fileName = resData['1']['fileName'];
      
      const outputKeysMapping = {
        SERVICE_VENDOR: 'ServiceVendor',
        SECTION: 'ServiceSection',
        SERVICE_NAME:  'ServiceName',	
        SERVICE_DESCRIPTION_INTERFACE:  'ServiceDescriptionInterface',	
        SERVICE_DESCRIPTION_MODULE: 'ServiceDescriptionModule',
        
        _3DI_VENDOR_NAME: '3diVendorName',	
        _3DI_PRODUCT_NAME: '3diProductName',
        _3DI_PRODUCT_DESCRIPTION: '3diProductDescription',	

        _3DI_VENDOR_ID: '3diVendorId',	
        _3DI_PRODUCT_ID:  '3diProductId',
        _3DI_EXCHANGE_ID:  '3diExchangeId',		

        _3DI_FILE_PROCESS_LOG:  '3diFileProcessingLog',
        IS_EXCHANGE:  'isExchange',		

      };

      const getExportJsonObject = () => {
        //console.log(resData);
       return Object.values(resData).map(row=>{
            // fileName = row.fileName;

            //console.log('rowrorwowrowo', row)
            //1 is override, check isExchange from userSelectedItem; 2 check matchItemType === 2, match multiple selection from exchange
            const verifyUserSelectIsExchangeOrNot = row?.processLog === "USER_OVERRIDE" ? row.userSelectedItem.isExchange : row?.matchedItemType === 2
            return {
              //original 
            [outputKeysMapping.SERVICE_VENDOR]: row.serviceVendor,
            [outputKeysMapping.SECTION]: row.serviceSection,
            [outputKeysMapping.SERVICE_NAME]: row.serviceName,
            [outputKeysMapping.SERVICE_DESCRIPTION_INTERFACE]: row.serviceDescriptionInterface,
            [outputKeysMapping.SERVICE_DESCRIPTION_MODULE]: row.serviceDescriptionModule,


            //user selected
            [outputKeysMapping._3DI_VENDOR_NAME]: row.userSelectedItem?.vendorName ,
            [outputKeysMapping._3DI_PRODUCT_NAME]: row.userSelectedItem?.productName ,
            [outputKeysMapping._3DI_PRODUCT_DESCRIPTION]: row.userSelectedItem?.description ,
            [outputKeysMapping._3DI_VENDOR_ID]: row.userSelectedItem?.vendorId ,

            [outputKeysMapping._3DI_PRODUCT_ID]: row.userSelectedItem?.productId,
            [outputKeysMapping._3DI_EXCHANGE_ID]:  row.userSelectedItem?.productId,

            [outputKeysMapping._3DI_FILE_PROCESS_LOG]: row?.processLog,
            [outputKeysMapping.IS_EXCHANGE]: verifyUserSelectIsExchangeOrNot
            }
          })
      };

      const getExportParams=(): String=>{
        const {showProjectType, showContentSummary, showProductCompetitors, showProductPricing, exportFormat} = exportConfig;
 
        var ret = "";

        if(showProjectType) {
          ret += "ProjectType";
        }

        if(showContentSummary) {
          if(ret.length > 0) {
            ret += "-";
          }
          ret += "ContentSummary";
        }

        if(showProductCompetitors) {
          if(ret.length > 0) {
            ret += "-";
          }
          ret += "ProductCompetitors";
        }

         if(showProductPricing) {
          if(ret.length > 0) {
            ret += "-";
          }
          ret += "ProductPricing";
        }

        if(exportFormat > 0) {
          if(ret.length > 0) {
            ret += "-";
          } 
          ret += "ExportOutputFormat:"+exportFormat
        }

        if(ret.length === 0) {
          ret = "none";
        }

           return ret;
      }
   

      //send to BE to populate description for use_override, project type for all, and project content summary

      const url = process.env.REACT_APP_API_SUBMITMAPPING;
      const {showProjectType, showContentSummary, showProductCompetitors, showProductPricing, exportFormat} = exportConfig;
          
      if(!url)return;
      const params = getExportParams();
      const urlPath = `${url}/${params}`
      await getTypeContentData(urlPath, getExportJsonObject())
          .then((resExportData)=>{

            //console.log("exportFormat: " + exportFormat)

            //console.log(resExportData);

              const resultJson = resExportData.ExportData;

              let maxProductCategoryCounts = {}
        
              // get the max numbers from the category lists
              if(exportFormat === EXPORT_FORMAT_FIXED_COLUMN) {
                  const categoryCount    = resExportData?.CategoryCounts;
                  const altCategoryCount = resExportData?.AltDataCategoryCounts;


                  const getMaxNumProductPricing: number = Math.max(...resultJson.map((item:{}) =>{
                          if(!item.hasOwnProperty('productPricing')) return 0;
                          return Array.isArray(item['productPricing']) ? (item['productPricing']).length : 0;
                      })
                  );

                  const maxCountsNormal = {
                      productTypes: categoryCount?.ProductType ?? 0,
                      regions:      categoryCount?.Region ?? 0,
                      markets:      categoryCount?.Market ?? 0,
                      dataTypes:    categoryCount?.DataType ?? 0,
                      deliveries:   categoryCount?.Delivery ?? 0,
                      tiers:        categoryCount?.Tier ?? 0,
                      competitors:  MAX_PRODUCT_COMPETITORS,
                      productPricing: getMaxNumProductPricing
                  };

                  const maxCountsAlt = {
                      productTypes: altCategoryCount?.ProductType ?? 0,
                      regions:      altCategoryCount?.Region ?? 0,
                      markets:      altCategoryCount?.Market ?? 0,
                      dataTypes:    altCategoryCount?.DataType ?? 0,
                      deliveries:   altCategoryCount?.Delivery ?? 0,
                      tiers:        altCategoryCount?.Tier ?? 0,
                      competitors:  MAX_PRODUCT_COMPETITORS,
                      productPricing: getMaxNumProductPricing
                  };


                  console.log("HEADER KEYS:", getExportHeaders(maxCountsNormal).map(c => c.key));
                  console.log("BASIC DTO KEYS:", Object.keys(resultJson?.[0]?.pimaBasicMappingDTO || {}));
                  console.log("PRODUCT TYPE DTO KEYS:", Object.keys(resultJson?.[0]?.productTypeDTO || {}));
                  console.log("CONTENT SUMMARY KEYS:", Object.keys(resultJson?.[0]?.productContentSummary || {}));
                  console.log("FIRST BASIC DTO:", resultJson?.[0]?.pimaBasicMappingDTO);


                  console.log("AD HEADER KEYS:", getExportHeaders(maxCountsAlt).map(c => c.key));
                  console.log("AD BASIC DTO KEYS:", Object.keys(resultJson?.[0]?.pimaBasicMappingDTO || {}));
                  console.log("AD PRODUCT TYPE DTO KEYS:", Object.keys(resultJson?.[0]?.productTypeDTO || {}));
                  console.log("AD CONTENT SUMMARY KEYS:", Object.keys(resultJson?.[0]?.productContentSummary || {}));
                  console.log("AD FIRST BASIC DTO:", resultJson?.[0]?.pimaBasicMappingDTO);

              }
              else {
    
                // get the max numbers from assigned categories
                
                //console.log('resultJson', url,resultJson);
                const getMaxNumProductTypes: number = Math.max(...resultJson.map((item:{}) =>{
                  if(!item.hasOwnProperty('productTypeDTO')) return 0;
                  return Array.isArray(item['productTypeDTO']['_3diProductTypes']) ? (item['productTypeDTO']['_3diProductTypes']).length : 0;
                  })
                ); 

                const getMaxNumRegions: number = Math.max(...resultJson.map((item:{}) =>{
                  if(!item.hasOwnProperty('productTypeDTO')) return 0;
                  return Array.isArray(item['productTypeDTO']['_3diRegions']) ? (item['productTypeDTO']['_3diRegions']).length : 0;
                  })
                ); 

                const getMaxNumMarkets: number = Math.max(...resultJson.map((item:{}) =>{
                  if(!item.hasOwnProperty('productTypeDTO')) return 0;
                  return Array.isArray(item['productTypeDTO']['_3diMarkets']) ? (item['productTypeDTO']['_3diMarkets']).length : 0;
                  })
                ); 

                const getMaxNumDataTypes: number = Math.max(...resultJson.map((item:{}) =>{
                  if(!item.hasOwnProperty('productTypeDTO')) return 0;
                  return Array.isArray(item['productTypeDTO']['_3diDataTypes']) ? (item['productTypeDTO']['_3diDataTypes']).length : 0;
                  })
                ); 

                const getMaxNumDeliveries: number = Math.max(...resultJson.map((item:{}) =>{
                  if(!item.hasOwnProperty('productTypeDTO')) return 0;
                  return Array.isArray(item['productTypeDTO']['_3diDeliveries']) ? (item['productTypeDTO']['_3diDeliveries']).length : 0;
                  })
                ); 

                const getMaxNumTiers: number = Math.max(...resultJson.map((item:{}) =>{
                  if(!item.hasOwnProperty('productTypeDTO')) return 0;
                  return Array.isArray(item['productTypeDTO']['_3diTiers']) ? (item['productTypeDTO']['_3diTiers']).length : 0;
                  })
                ); 

                const getMaxNumCompetitors: number = Math.max(...resultJson.map((item:{}) =>{
                  if(!item.hasOwnProperty('productCompetitor')) return 0;
                  return Array.isArray(item['productCompetitor']['_3diProductCompetitors']) ? (item['productCompetitor']['_3diProductCompetitors']).length : 0;
                  })
                ); 

                const getMaxNumProductPricing: number = Math.max(...resultJson.map((item:{}) =>{
                  if(!item.hasOwnProperty('productPricing')) return 0;
                  return Array.isArray(item['productPricing']) ? (item['productPricing']).length : 0;
                  })
                ); 

                maxProductCategoryCounts = {
                  productTypes: getMaxNumProductTypes,
                  regions: getMaxNumRegions,
                  markets: getMaxNumMarkets,
                  dataTypes: getMaxNumDataTypes,
                  deliveries: getMaxNumDeliveries,
                  tiers: getMaxNumTiers,
                  competitors: getMaxNumCompetitors,
                  productPricing: getMaxNumProductPricing
                };
              }

                //console.log(getMaxProductCategoryCounts);

              let jsonRes: any[]=[];


              jsonRes = [...resultJson]

              const isAltDataRow = (res: any): boolean => {
                  const basic = res['pimaBasicMappingDTO'];
                  return !!(basic?.isAltData ?? basic?.altData ?? false);
              };

              const normalJsonRes = jsonRes.filter((res: any) => !isAltDataRow(res));
              const altJsonRes    = jsonRes.filter((res: any) =>  isAltDataRow(res));


              const mapResToRows = (res: any, counts: any) => {
                  const basicProductResponse = res['pimaBasicMappingDTO'];
                  return formatResultJsonByConfig(
                      res,
                      counts,
                      basicProductResponse.isExchange
                  );
              };

              let maxCountsNormal: any = {};
              let maxCountsAlt: any = {};

              if (exportFormat === EXPORT_FORMAT_FIXED_COLUMN) {
                  const categoryCount    = resExportData?.CategoryCounts;
                  const altCategoryCount = resExportData?.AltDataCategoryCounts;


                  const getMaxNumProductPricing: number = Math.max(...resultJson.map((item:{}) =>{
                          if(!item.hasOwnProperty('productPricing')) return 0;
                          return Array.isArray(item['productPricing']) ? (item['productPricing']).length : 0;
                      })
                  );

                  maxCountsNormal = {
                      productTypes: categoryCount?.ProductType ?? 0,
                      regions:      categoryCount?.Region ?? 0,
                      markets:      categoryCount?.Market ?? 0,
                      dataTypes:    categoryCount?.DataType ?? 0,
                      deliveries:   categoryCount?.Delivery ?? 0,
                      tiers:        categoryCount?.Tier ?? 0,
                      competitors:  MAX_PRODUCT_COMPETITORS,
                      productPricing: getMaxNumProductPricing
                  };

                  maxCountsAlt = {
                      productTypes: altCategoryCount?.ProductType ?? 0,
                      regions:      altCategoryCount?.Region ?? 0,
                      markets:      altCategoryCount?.Market ?? 0,
                      dataTypes:    altCategoryCount?.DataType ?? 0,
                      deliveries:   altCategoryCount?.Delivery ?? 0,
                      tiers:        altCategoryCount?.Tier ?? 0,
                      competitors:  MAX_PRODUCT_COMPETITORS,
                      productPricing: getMaxNumProductPricing
                  };
              } else {
                  maxCountsNormal = maxProductCategoryCounts;
                  maxCountsAlt    = maxProductCategoryCounts;
              }

              const exportRowsMain = normalJsonRes.flatMap(res => mapResToRows(res, maxCountsNormal));
              const exportRowsAlt  = altJsonRes.flatMap(res => mapResToRows(res, maxCountsAlt));


              const workbook = new ExcelJS.Workbook();

              const styleWorksheet = (ws: any) => {
                  ws.eachRow({ includeEmpty: true }, (row: any, rowNumber: number) => {
                      row.eachCell((cell: any) => {
                          cell.alignment = {
                              vertical: 'top',
                              horizontal: 'left',
                              wrapText: true,
                          };
                          if (rowNumber === 1) {
                              cell.font = {
                                  bold: true,
                                  color: { argb: 'e87722' },
                              };
                          }
                      });
                  });
              };

              const worksheetMain = workbook.addWorksheet('3di mapping results');
              worksheetMain.columns = getExportHeaders(maxCountsNormal);
              worksheetMain.addRows(exportRowsMain);
              styleWorksheet(worksheetMain);

              if (exportRowsAlt.length > 0) {
                  const worksheetAlt = workbook.addWorksheet('3di mapping results - alt data');
                  // Columns A–H identical, and category headers structure reused
                  worksheetAlt.columns = getExportHeaders(maxCountsAlt);
                  worksheetAlt.addRows(exportRowsAlt);
                  styleWorksheet(worksheetAlt);
              }

              workbook.xlsx.writeBuffer()
                  .then((buffer: any) => saveAs(new Blob([buffer]), fileName))
                  .catch((err: any) => console.log('Error writing excel export', err));


          });
    // };
    };

    let default_width = 25;

    const getDynamicProductTypeColumns=(getMaxProductCategoryCounts: any)=>{
      
      let dynamicProductTypeColumns = [];//3di product types
      for(let i: number=1; i<= getMaxProductCategoryCounts.productTypes; i++){
        const productTypeObj={
          header: `3di Product Types (${i})`,
          key: `_3diProductTypes(${i})`,
          width: default_width
        };
        dynamicProductTypeColumns.push(productTypeObj);
      }

      for(let i: number=1; i<= getMaxProductCategoryCounts.regions; i++){
        const productTypeObj={
          header: `3di Regions (${i})`,
          key: `_3diRegions(${i})`,
          width: default_width
        }
        dynamicProductTypeColumns.push(productTypeObj);
      };

      for(let i: number=1; i<= getMaxProductCategoryCounts.markets; i++){
        const productTypeObj={
          header: `3di Markets (${i})`,
          key: `_3diMarkets(${i})`,
          width: default_width
        }
        dynamicProductTypeColumns.push(productTypeObj);
      };

      for(let i: number=1; i<= getMaxProductCategoryCounts.dataTypes; i++){
        const productTypeObj={
          header: `3di Data Types (${i})`,
          key: `_3diDataTypes(${i})`,
          width: default_width
        }
        dynamicProductTypeColumns.push(productTypeObj);
      };

      for(let i: number=1; i<= getMaxProductCategoryCounts.deliveries; i++){
        const productTypeObj={
          header: `3di Deliveries (${i})`,
          key: `_3diDeliveries(${i})`,
          width: default_width
        }
        dynamicProductTypeColumns.push(productTypeObj);
      };

      for(let i: number=1; i<= getMaxProductCategoryCounts.tiers; i++){
        const productTypeObj={
          header: `3di Tiers (${i})`,
          key: `_3diTiers(${i})`,
          width: default_width
        }
        dynamicProductTypeColumns.push(productTypeObj);
      };

      return dynamicProductTypeColumns;
      
    }

    const getDynamicProductCompetitorColumns=(getMaxNumCompetitorsCount: any)=>{
      
      let dynamicProductCompetitorColumns = [];//3di product types
      for(let i: number=1; i<= getMaxNumCompetitorsCount.competitors; i++){
        const productTypeObj={
          header: `3di Product Alternatives (${i})`,
          key: `_3diProductCompetitors(${i})`,
          width: default_width
        };
        dynamicProductCompetitorColumns.push(productTypeObj);
      }

      return dynamicProductCompetitorColumns;
      
    }

    const getDynamicProductPricingColumns=(getMaxProductCategoryCounts: any)=>{
      
      let dynamicProductTypeColumns = [];//3di product types

      for(let i: number=1; i<= getMaxProductCategoryCounts.productPricing; i++){
   
         const columns = [
          { header: `3di Pricing - Product/Component Name (${i})`, key:  `_3diPricingProductName(${i})`, width: default_width },
          { header: `3di Pricing - Currency (${i})`, key: `_3diPricingCurrency(${i})`, width: default_width },
          { header: `3di Pricing - Minimum (${i})`, key: `_3diPricingMinimum(${i})`, width: default_width },
          { header: `3di Pricing - Maximum (${i})`, key: `_3diPricingMaximum(${i})`, width: default_width },
          { header: `3di Pricing - Price Category (${i})`, key: `_3diPricingCategory(${i})`, width: default_width },
          { header: `3di Pricing - Term (${i})`, key: `_3diPricingTerm(${i})`, width: default_width },
          { header:  `3di Pricing - Description (${i})`, key: `_3diPricingDescription(${i})`, width: default_width },
        ];

        dynamicProductTypeColumns.push(...columns);

      };

      return dynamicProductTypeColumns;
      
    }


    const getExportHeaders =(getMaxProductCategoryCounts: any)=>{
      
      const {showProjectType, showContentSummary, showProductCompetitors, showProductPricing, exportFormat} = exportConfig;

      let retHeaders: any[] = []

      let contentCoverageHeaders : any = []
      let productCategoryHeaders : any = []
      let productCompetitorHeader : any = []
      let productPricingHeaders : any = []

      // always in the export
      const staticColumns = [//basic information from client and 3di
        { header: 'Service Vendor', key: 'serviceVendor', width: default_width }, 
        { header: 'Service Section', key:'serviceSection', width: default_width }, 
        { header: 'Service Name', key:'serviceName', width: default_width }, 
        { header: 'Service Description Interface', key: 'serviceDescriptionInterface', width: default_width }, 
        { header: 'Service Description Module', key: 'serviceDescriptionModule', width: default_width }, 
        { header: '3di Vendor Name', key: '_3diVendorName', width: default_width }, 
        { header: '3di Product Name', key:'_3diProductName', width: default_width }, 
        { header: '3di Product Description', key: '_3diProductDescription', width: default_width }
      ]

      const staticColumnsProfilerIds = [//basic information from client and 3di
        { header: '3di VendorId', key:'_3diVendorId', width: default_width }, 
        { header: '3di ProductId', key: '_3diProductId', width: default_width }, 
        { header: '3di ExchangeId', key: '_3diExchangeId', width: default_width }
        // { label: '3di FileProcessingLog',value:'_3diFileProcessingLog'},
      ]

      if(showContentSummary) {
        contentCoverageHeaders = [//3di coverage summary
          { header: '3di Coverage Summary: Fixed Income', key: '_3diConverageSummary_FixedIncome', width: default_width }, 
          { header: '3di Coverage Summary: Equity', key: '_3diConverageSummary_Equity', width: default_width }, 
          { header: '3di Coverage Summary: Commodity', key: '_3diConverageSummary_Commodity', width: default_width }
        ]
      }

      if(showProjectType) {
          if (exportFormat === EXPORT_FORMAT_EXTENDED_VARIABLE_ROWS) {

           productCategoryHeaders = [
              { header: '3di Product Types', key: '_3diProductTypes', width: default_width },
              { header: '3di Regions', key: '_3diRegions', width: default_width },
              { header: '3di Markets', key: '_3diMarkets', width: default_width },
              { header: '3di Data Types', key: '_3diDataTypes', width: default_width },
              { header: '3di Deliveries', key: '_3diDeliveries', width: default_width },
              { header: '3di Tiers', key: '_3diTiers', width: default_width },
            ]
          } else {
              productCategoryHeaders = getDynamicProductTypeColumns(getMaxProductCategoryCounts)
          }
      }

      if(showProductCompetitors) {
           if (exportFormat === EXPORT_FORMAT_EXTENDED_VARIABLE_ROWS ) {
           productCompetitorHeader = [
                { header: '3di Product Alternatives', key: '_3diProductCompetitors', width: default_width },
            ]
          } else {
           productCompetitorHeader = getDynamicProductCompetitorColumns(getMaxProductCategoryCounts);
          }
      }

      if(showProductPricing) {
        if (exportFormat === EXPORT_FORMAT_EXTENDED_VARIABLE_ROWS) {
          productPricingHeaders = [
            { header: '3di Pricing - Product/Component Name', key: '_3diPricingProductName', width: default_width },
            { header: '3di Pricing - Currency', key: '_3diPricingCurrency', width: default_width },
            { header: '3di Pricing - Minimum', key: '_3diPricingMinimum', width: default_width },
            { header: '3di Pricing - Maximum', key: '_3diPricingMaximum', width: default_width },
            { header: '3di Pricing - Price Category', key: '_3diPricingCategory', width: default_width },
            { header: '3di Pricing - Term', key: '_3diPricingTerm', width: default_width },
            { header: '3di Pricing - Description', key: '_3diPricingDescription', width: default_width },
          ];

        } else {
          productPricingHeaders = getDynamicProductPricingColumns(getMaxProductCategoryCounts)
        }
      }

      

      // if fixed, move pricing to end of file as pricing record count vary by product
      if(exportFormat === EXPORT_FORMAT_FIXED_COLUMN) {

          retHeaders = [...staticColumns]
          if(showContentSummary) { retHeaders.push(...contentCoverageHeaders) }
          if(showProjectType) { retHeaders.push(...productCategoryHeaders) }
          if(showProductCompetitors) { retHeaders.push(...productCompetitorHeader) }

          // add the ids to the end of the file
          retHeaders.push(...staticColumnsProfilerIds);

          if(showProductPricing) { retHeaders.push(...productPricingHeaders) }
          
      }
      else {
          retHeaders = [...staticColumns]
          if(showContentSummary) { retHeaders.push(...contentCoverageHeaders) }
          if(showProjectType) { retHeaders.push(...productCategoryHeaders) }
          if(showProductCompetitors) { retHeaders.push(...productCompetitorHeader) }
          if(showProductPricing) { retHeaders.push(...productPricingHeaders) }
          
          // add the ids to the end of the file
          retHeaders.push(...staticColumnsProfilerIds);
      }

      return retHeaders;

    }

    const formatResultJsonByConfig=(resItem: any, getMaxProductCategoryCounts: any, isExchange: boolean)=>{
      const {showProjectType, showContentSummary, showProductCompetitors, showProductPricing, exportFormat} = exportConfig;
     
      
      const exportRows: any[] = [];
      
      const basicProductInfo = resItem['pimaBasicMappingDTO'];

      let productTypes: any[] = [];
      let regions: any[] = [];
      let markets: any[] = [];
      let dataTypes: any[] = [];
      let deliveries: any[] = [];
      let tiers: any[] = [];
      let productContentSummary: any = {};
      let productCompetitor: any[] = [];
      let productPricing: any[] = [];


      if(showContentSummary) {
          const pcs = resItem['productContentSummary'] || {};
          productContentSummary = {
              _3diConverageSummary_FixedIncome: pcs._3diConverageSummary_FixedIncome ?? pcs.fixedIncome ?? pcs.fixed ?? '',
              _3diConverageSummary_Equity:      pcs._3diConverageSummary_Equity      ?? pcs.equityIncome ?? pcs.equity ?? '',
              _3diConverageSummary_Commodity:   pcs._3diConverageSummary_Commodity   ?? pcs.commodityIncome ?? pcs.commodity ?? '',
          };
      }

      if(showProjectType) {
        productTypes = Array.isArray(resItem['productTypeDTO']._3diProductTypes) ? resItem['productTypeDTO']._3diProductTypes : [resItem['productTypeDTO']._3diProductTypes]
        regions = Array.isArray(resItem['productTypeDTO']._3diRegions) ? resItem['productTypeDTO']._3diRegions : [resItem['productTypeDTO']._3diRegions]
        markets = Array.isArray(resItem['productTypeDTO']._3diMarkets) ? resItem['productTypeDTO']._3diMarkets : [resItem['productTypeDTO']._3diMarkets]
        dataTypes = Array.isArray(resItem['productTypeDTO']._3diDataTypes) ? resItem['productTypeDTO']._3diDataTypes : [resItem['productTypeDTO']._3diDataTypes]
        deliveries = Array.isArray(resItem['productTypeDTO']._3diDeliveries) ? resItem['productTypeDTO']._3diDeliveries : [resItem['productTypeDTO']._3diDeliveries]
        tiers = Array.isArray(resItem['productTypeDTO']._3diTiers) ? resItem['productTypeDTO']._3diTiers : [resItem['productTypeDTO']._3diTiers]

        if(isExchange) {
          productTypes.push("Exchange");
        }

      }

      if(showProductCompetitors) {
        productCompetitor = resItem['productCompetitor']?.['_3diProductCompetitors'] || [];
      }

      if(showProductPricing) {
        productPricing = resItem['productPricing'] || [];
      }

   
      if(exportFormat === EXPORT_FORMAT_EXTENDED_VARIABLE_ROWS) {

       
        let maxCount = 0; 

        
        if(showProjectType) {
          
          maxCount = Math.max(productTypes.length,
            regions.length,
            markets.length,
            dataTypes.length,
            deliveries.length,
            tiers.length
          )

        }

        if(showProductCompetitors) {
          maxCount = Math.max(
            maxCount,
            productCompetitor.length
          )
        }

        if(showProductPricing) {
          maxCount = Math.max(
            maxCount,
            productPricing.length
          )
        }

        // setting to 1 so at least the first row will render the basic info
        if(maxCount === 0) {
          maxCount = 1;
        }


        //if(getMaxProductCategoryCounts.productTypes > maxCount) { maxCount = getMaxProductCategoryCounts.productTypes }
        //if(getMaxProductCategoryCounts.regions > maxCount) { maxCount = getMaxProductCategoryCounts.regions }
        //if(getMaxProductCategoryCounts.markets > maxCount) { maxCount = getMaxProductCategoryCounts.markets }
        //if(getMaxProductCategoryCounts.deliveries > maxCount) { maxCount = getMaxProductCategoryCounts.deliveries }
        //if(getMaxProductCategoryCounts.tiers > maxCount) { maxCount = getMaxProductCategoryCounts.tiers }
        //if(getMaxProductCategoryCounts.competitors > maxCount) { maxCount = getMaxProductCategoryCounts.competitors }
        //if(getMaxProductCategoryCounts.productPricing > maxCount) { maxCount = getMaxProductCategoryCounts.productPricing }

        //console.log("maxCount: " + maxCount);
        
        
        for(let i = 0; i < maxCount; i++) {
          let row: any = {}

          row = {...basicProductInfo}

          // does not need any processing so can be directly merged
          if(showContentSummary) {
            row = { ...row, ...productContentSummary };
          }

          // add a new prop to the row
          if(showProductCompetitors) {

            let val = "";
            if(productCompetitor[i]  !== undefined) {
              val = productCompetitor[i]
            }

            row[`_3diProductCompetitors`] = val;
          }

          if(showProductPricing) {

            let val = {
              _3diPricingProductName: productPricing[i]?.component || '',
              _3diPricingCurrency: productPricing[i]?.currency || '',
              _3diPricingMinimum:  productPricing[i]?.min || '',
              _3diPricingMaximum: productPricing[i]?.max || '',
              _3diPricingCategory: productPricing[i]?.priceGroup || '',
              _3diPricingTerm: productPricing[i]?.priceTerm || '',
              _3diPricingDescription: productPricing[i]?.comments || ''
            }
              
             row = { ...row, ...val };

          }


          if(showProjectType) {

            let val = {
             _3diProductTypes: productTypes[i] || '',
             _3diRegions: regions[i] || '',
             _3diMarkets: markets[i] || '',
             _3diDataTypes: dataTypes[i] || '',
             _3diDeliveries: deliveries[i] || '',
             _3diTiers: tiers[i] || '',
            }
          
             row = { ...row, ...val };
          }

          exportRows.push(row);
        }



      }
      else {

        // horizontal numbered column names

        let row: any = {};

        row = {...basicProductInfo}

        if(showContentSummary) {
          row = { ...row, ...productContentSummary };
        }

        if(showProductCompetitors) {

          for(let i: number = 0; i < getMaxProductCategoryCounts.competitors; i++) {
            row[`_3diProductCompetitors(${(i+1)})`] = productCompetitor[i] || '';
          }
           
        }

        if(showProductPricing) {

          for(let i: number = 0; i < getMaxProductCategoryCounts.productPricing; i++) {
            row[`_3diPricingProductName(${(i+1)})`] = productPricing[i]?.component || '';
            row[`_3diPricingCurrency(${(i+1)})`] = productPricing[i]?.currency || '';
            row[`_3diPricingMinimum(${(i+1)})`] = productPricing[i]?.min || '';
            row[`_3diPricingMaximum(${(i+1)})`] = productPricing[i]?.max || '';
            row[`_3diPricingCategory(${(i+1)})`] = productPricing[i]?.priceGroup || '';
            row[`_3diPricingTerm(${(i+1)})`] = productPricing[i]?.priceTerm || '';
            row[`_3diPricingDescription(${(i+1)})`] = productPricing[i]?.comments || '';
          }
           
        }


        if(showProjectType) {

         
          for(let i: number = 0; i < getMaxProductCategoryCounts.productTypes; i++) {
              row[`_3diProductTypes(${i + 1})`] = productTypes[i] || '';
          }

          for(let i: number = 0; i < getMaxProductCategoryCounts.regions; i++) {
              row[`_3diRegions(${i + 1})`] = regions[i] || '';
          }

          for(let i: number = 0; i < getMaxProductCategoryCounts.markets; i++) {
              row[`_3diMarkets(${i + 1})`] = markets[i] || '';
          }

          for(let i: number = 0; i < getMaxProductCategoryCounts.dataTypes; i++) {
              row[`_3diDataTypes(${i + 1})`] = dataTypes[i] || '';
          }

          for(let i: number = 0; i < getMaxProductCategoryCounts.deliveries; i++) {
              row[`_3diDeliveries(${i + 1})`] = deliveries[i] || '';
          }

          for(let i: number = 0; i < getMaxProductCategoryCounts.tiers; i++) {
              row[`_3diTiers(${i + 1})`] = tiers[i] || '';
          }
          
        }

        exportRows.push(row)


      }

      //console.log(exportRows);
      return exportRows;
    }
   
    const filterByShowAll=()=>{
      //console.log('filterByShowAll', resData, Object.values(resData))
      return toggleShowAll?  Object.values(resData): 
        Object.values(resData).filter(o => o.status !==1 && o.status !== 2 )
    }

    const StyledTableCell = styled(TableCell)({
      paddingTop: 16,
      paddingBottom: 8,
    })

    
    const StyledHeaderTableCell = styled(TableCell)({
      // paddingTop: '8',
      // paddingBottom: 8,
      font: stylesConfig.typography.filterItem.font,
      // font: 'normal normal normal 15px/19px  Lato , sans-serif',
      fontWeight: 600,
      letterSpacing: '0px',
      color: stylesConfig.colors.white,
      backgroundColor: stylesConfig.tiles.govTile
    })

    const downloadSampleFileByName = (event:any) =>{
      event.preventDefault();
                {/* <%=request.getContextPath()%>/download/MDM Importer Service Upload Template.xlsx */}

      let fileName = 'MDM Importer Service Upload Template.xlsx'
      //const downloadUrl = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PROD_TEMPLATE_DOWNLOAD : process.env.REACT_APP_DEV_TEMPLATE_DOWNLOAD
      const downloadUrl = process.env.REACT_APP_TEMPLATE_DOWNLOAD;
      
      let url = downloadUrl
      //downloadUrl + fileName;
      let headers = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      }
      fetch(url, headers)
        .then(response => {
          if (response.status >= 200 && response.status <= 299) {
            fileName = (response && response.headers &&
                response.headers.get('Content-Disposition')) 
                   ? response?.headers
            ?.get('Content-Disposition').split('filename=')[1]: '';
            return response.blob();
          } else {
            throw Error(response.statusText);
          }
        })
        .then(blob => {
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(error => {
            // this.setState({ showAlert: true });
        });
    }
    const handleConfigChange=(e:any)=>{
      //console.log(e.target.name)
      const {name} = e.target
      switch(name){
        case "showResultBeforeExport":
          setExportConfig((prev)=>{
            return {
                ...prev,
            showResultBeforeExport: !prev['showResultBeforeExport']
            }
          })
        break

        case "showProjectType":
          setExportConfig((prev)=>{
            return {
                ...prev,
                showProjectType: !prev['showProjectType']
            }
          })
        break

        case "showContentSummary":
          setExportConfig((prev)=>{
            return {
                ...prev,
                showContentSummary: !prev['showContentSummary']
            }
          })
        break

        case "showProductCompetitors":
          setExportConfig((prev)=>{
            return {
                ...prev,
                showProductCompetitors: !prev['showProductCompetitors']
            }
          })
        break

         case "showProductPricing":
          setExportConfig((prev)=>{
            return {
                ...prev,
                showProductPricing: !prev['showProductPricing']
            }
          })
        break

        
        default:
          setExportConfig((prev)=>{
            return {
                ...prev,
            }
          })
          break
      }
    }

    const handleExportFormatChange=(e:SelectChangeEvent)=>{
      const {value} = e.target;
      setExportConfig((prev)=>{
            return {
                ...prev,
            exportFormat: parseInt(value)
            }
          })
    }

    const logData = (event: any) => {
      console.log(resData);
    }

  return (
    <SettingsLayout heading={undefined} toolbar={undefined} loading={undefined} actions={undefined} isGlobalSearching={undefined}>
           {_.isEmpty(resData) && ( <PimaForm 
                handleEmailChange={handleEmailChange} 
                handleFileChange={handleFileChange } 
                handleSubmit={handleSubmit } 
                isSuccess={isSuccess} 
                isLoading={isLoading} 
                progress={progress}  
                formValues={formValues}
                handleConfigChange={handleConfigChange}
                handleExportFormatChange={handleExportFormatChange}
                exportConfig={exportConfig}
            />)}

            {!_.isEmpty(resData) && (
                <>
                <FormControlLabel 
                      control={
                        <Checkbox
                            checked={toggleShowAll || false}
                            onChange={() => setToggleShowAll((toggle)=>!toggle)}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />
                        }
                       label="Show All Rows" 
                     />
               <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <StyledHeaderTableCell>Row</StyledHeaderTableCell>
                                <StyledHeaderTableCell align="left">Service Vendor</StyledHeaderTableCell>
                                <StyledHeaderTableCell align="left">Service Section</StyledHeaderTableCell>
                                <StyledHeaderTableCell align="left">Service Name</StyledHeaderTableCell>
                                {/* <StyledHeaderTableCell align="left">Process Logs</StyledHeaderTableCell> */}
                                <StyledHeaderTableCell align="left">Service Description-Interface</StyledHeaderTableCell>

                                <StyledHeaderTableCell align="left">3di Product</StyledHeaderTableCell>
                                <StyledHeaderTableCell align="left">Override</StyledHeaderTableCell>
                                {/* <StyledHeaderTableCell align="left">Debug</StyledHeaderTableCell> */}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {filterByShowAll().map((row:any, index: number, array) => (
                            <TableRow
                            key={row.row}
                            hover
                            //validated red border
                            sx={{ '&:last-child td, &:last-child th': { border: 0 }, 
                                  border: errorRows.includes(row.row) ? '2px solid red' : 'null'
                                }}
                            >
                                    <StyledTableCell component="th" scope="row">
                                        {row.row}
                                    </StyledTableCell>
                                    <StyledTableCell align="left">{row.serviceVendor}</StyledTableCell>
                                    <StyledTableCell align="left">{row.serviceSection}</StyledTableCell>
                                    <StyledTableCell align="left">{row.serviceName}</StyledTableCell>
                                    {/* <StyledTableCell align="left">{row?.vendorLog?.split('-').map(t=>(<li>{t}</li>))}</StyledTableCell> */}

                                    {/* Description interface */}
                                    <StyledTableCell align="left">{row.serviceDescriptionInterface}</StyledTableCell>
                                    
                                    {/* 3di Product */}
                                    <StyledTableCell align="left">
                                        <DropDown 
                                            isDisabled={overideItems[index]?.isChecked || false }
                                            index={index} 
                                            row={row || null}
                                            handleSelectionChange={handleSelectionChange}
                                            handleDropdownCopy={handleDropDownCopyClick}
                                            isLastItem={index === array.length -1}
                                        />
                                      </StyledTableCell>
                                    
                                    {/* Override */}
                                    <StyledTableCell align="left">
                                        <OverideHotSearchAndCopy
                                            index={index}
                                            row={row || null}
                                            hotWord={overideItems[index]?.checkedItem}
                                            handleCopyClick={handleCopyClick}
                                            handleAsyncHotWordToParentByIndex={handleAsyncHotWordToParentByIndex}
                                            isChecked={overideItems[index]?.isChecked || null}
                                            checkboxOnChange={checkboxOnChange}
                                            isLastItem={index === array.length -1}
                                        />
                                    </StyledTableCell>
                                    {/*<StyledTableCell align="left">{row.productLog}</StyledTableCell>*/}
                            </TableRow>
                        )
                        
                        )}
                        </TableBody>
                    </Table>
                </TableContainer>

                <br/><br/>
                {/* <input type="submit" value="Export Results" id="updateSubmit" name="submitBtn" /> */}
                <PrimaryButton
                  text="Export Results"
                  buttonIcon={undefined}   
                  onClick={downloadExcel}            
                   />

            <br/><br/>
                <Link to="/" onClick={() => window.location.reload()} >Click here to start again</Link><br/>
                {/* <a href="#" onClick={logData}>log data</a>*/}
                </>
                
           ) }
            <div>
            <h4>Notes for using this tool</h4>
            <ul>
                <li>The process may take a long time if uploading a large dataset, wait for the process to complete and do not press back or refresh the page.</li>
                <li>Make sure to use the correct excel file, using an incorrectly formatted excel file may not return correct results.</li>
                <li>If you need a template to populate to perform an upload please click <a href="#" onClick={downloadSampleFileByName} target="_blank">here</a> to download</li>           
            </ul>
            </div>

        </SettingsLayout>

  );
};

export default PimaUpload;
